import { Brick, registerBrick } from "olympe";

export default class FormatDataStructure extends Brick {
  /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {ListDef} summary
   * @param {function()} forwardEvent
   * @param {function(ListDef)} setFormattedData
   * @param {function(*)} setErrorFlow
   */
  update($, [summary], [forwardEvent, setFormattedData, setErrorFlow]) {
    try {
      function buildTableStructure(data) {
        return data.map((table) => {
          const structure = {
            Name: "",
            meta: {},
            columns: [],
          };

          const nameObj = table.find(
            (item) =>
              "Name" in item && "Owner" in item && "Created_datetime" in item
          );
          if (nameObj) {
            structure.Name = nameObj.Name;
          }

          const indexObj = table.find(
            (item) =>
              "index_name" in item &&
              "index_description" in item &&
              "index_keys" in item
          );
          if (indexObj) {
            structure.meta.index_name = indexObj.index_name;
            structure.meta.index_description = indexObj.index_description;
            structure.meta.index_keys = indexObj.index_keys;
          }

          const constraintObjs = table.filter(
            (item) =>
              "constraint_type" in item &&
              "constraint_name" in item &&
              "constraint_keys" in item
          );
          if (constraintObjs.length > 0) {
            structure.meta.constraint = constraintObjs.map((item) => ({
              name: item.constraint_name,
              keys: item.constraint_keys,
              type: item.constraint_type,
            }));
          }

          for (const item of table) {
            if ("Column_name" in item) {
              structure.columns.push({
                Column_name: item.Column_name,
                Type: item.Type,
                Length: item.Length,
                Nullable: item.Nullable,
              });
            }
          }

          return structure;
        });
      }

      function transformData(rawSummary) {
        const simplified = rawSummary.map((entry) => entry[0]);

        try {
          const results = buildTableStructure(simplified);
          return { results, errorTables: [] };
        } catch (err) {
          console.error("Error while building table structures:", err);
          return { results: [], errorTables: rawSummary };
        }
      }

      const { results, errorGroups } = transformData(summary);

      if (errorGroups.length > 0) {
        setErrorFlow(errorGroups.join("\n"));
      }
      setFormattedData(JSON.stringify(results, null, 2));
      forwardEvent();
    } catch (error) {
      console.error("Error during execution:", error);
      setErrorFlow(ErrorFlow.create(`Error: ${error.message || error}`));
    }
  }
}

registerBrick("01982bce7527193f968b", FormatDataStructure);
